import firebase from "firebase/app";

import { Divider } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import getDistributionChannelsQuery from "astrid-firestore/src/api/distribution/getDistributionChannelsQuery";
import updateOrganization from "astrid-firestore/src/api/organizations/updateOrganization";
import { nullable, object, string } from "astrid-firestore/src/types/_types";

import Form from "../../../forms/components/Form/Form";
import useSimpleForm from "../../../forms/hooks/useSimpleForm";
import PipelineStepActionArgs from "../../../pipelines/components/PipelineForm/components/PipelineStepActionArgs";
import PipelineStepActionSelect from "../../../pipelines/components/PipelineForm/components/PipelineStepActionSelect";

export default function DistributionArgsForm({ publisher, editData = null, onClose }) {
	const { t } = useTranslation();

	const { form, onSubmit, error, watch } = useSimpleForm({
		schema: object({
			channel: object(),
			action: object(),
			condition: nullable(string()),
			args: object(),
			conditionalArgs: nullable(object().passthrough()),
		}),
		defaultValues: {
			channel: editData ? { id: editData?.channelId } : null,
			action: editData ? { action: editData.action } : null,
			condition: editData ? editData?.conditionalArgs?.condition : null,
			args: editData ? { args: editData?.args } : null,
			conditionalArgs: editData ? { args: editData?.conditionalArgs } : null,
		},
		onSubmit: ({ channel, action, args, condition, conditionalArgs }) => {
			return updateOrganization(firebase, publisher.ref, {
				distribution: {
					channels: {
						[channel.id]: {
							actions: {
								[action.action]: {
									args: args.args,
									conditionalArgs: condition ? { condition, ...conditionalArgs?.args } : null,
								},
							},
						},
					},
				},
			});
		},
		onSuccess: onClose,
	});

	const { action, condition } = watch();

	return (
		<Form.Modal
			form={form}
			header={t("addArgs", "Add args")}
			size="tiny"
			onSubmit={onSubmit}
			onClose={onClose}
			error={error}
		>
			<Form.CollectionSelect
				name="channel"
				label={t("channel", "Channel")}
				query={getDistributionChannelsQuery(firebase)}
			/>

			<PipelineStepActionSelect name="action" />

			<Form.Field name="args">
				<PipelineStepActionArgs name="root" action={action?.action} />
			</Form.Field>

			<Divider />

			<Form.Input name="condition" label={t("condition", "Condition")} />
			{condition && (
				<Form.Field name="conditionalArgs">
					<PipelineStepActionArgs name="root2" action={action?.action} />
				</Form.Field>
			)}
		</Form.Modal>
	);
}
